








































import Vue from "vue"
import RichModal from "~/components/guideline/modal/RichModal.vue"
import ConversionButton from "~/components/guideline/button/ConversionButton.vue"

export default Vue.extend({
  components: {
    RichModal,
    ConversionButton,
  },
  props: {
    isShown: {
      type: Boolean,
      default: false,
    },
    headTitle: {
      type: String,
      required: true,
    },
    numberOfHits: {
      type: Number,
      default: null,
    },
    isShowableNumberOfHits: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    numberOfHitsText(): string {
      if (!this.numberOfHits && this.numberOfHits !== 0) {
        return "該当者 -"
      }
      return this.numberOfHits > 1000
        ? "該当者 1,000 名以上"
        : `該当者 ${this.numberOfHits.toLocaleString()} 名`
    },
  },
  methods: {
    handleClose() {
      this.$emit("close")
    },
    handleClear() {
      this.$emit("clear")
    },
    handleSearch() {
      this.$emit("search")
    },
  },
})
